<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { navigateTo } from '#imports'
</script>

<template>
  <div class="my-16 flex items-center justify-center ys-about-card-end mx-4">
    <div class="grid place-items-center">
      <h1 class="ys-about-text mb-6 text-[24px] text-center md:text-left lg:text-[34px] lg:leading-8" style=" font-weight: 400 ;">
        {{ $t("Can't find what you're looking for?") }}
      </h1>
      <h1 class="ys-card-description-text mb-4">
        {{ $t("We're here to help.") }}
      </h1>
      <Button @click="navigateTo('/contacts/')" class="ys-button w-full md:w-[350px]" >{{ $t("Contact us") }}</Button>
    </div>
  </div>
</template>

<style scoped lang="scss">

.ys-about-card-end {
  height: 261px;
  border-radius: 36px;
  background: rgba(247, 254, 248, 1);
}

.ys-about-text {
  font-family: Involve, sans-serif;
  color: rgba(0, 0, 0, 1);
  font-weight: 500;
  line-height: 34px;
}


.ys-card-description-text {
  font-size: 18px;
  font-weight: 400;
  line-height: 21.78px;
  text-align: center;
  color: rgba(10, 13, 20, 1);
}
</style>